import {uiPartCreateNamespacedParts} from "@wix/devzai-utils-common";

export const DoppeActionTypeWidgetContentLayoutNewSectionsAndButtonsParts = uiPartCreateNamespacedParts('DoppeActionTypeWidgetContentLayoutNewSectionsAndButtonsParts', {
    Buttons: 'Buttons',
    Sections: 'Sections',
    Content: 'Content',
})